import { useQuery } from "@tanstack/react-query";
import CategoriesSection from "../components/home/categories-section";
import Hero from "../components/home/hero";
import ProductsSection from "../components/home/products-section";
import { getHomePage } from "../actions/getHomePage";
import { useTranslation } from "react-i18next";
import HomeProductsSection from "../components/home/home-products-section";
import HomeShopsSection from "../components/home/home-shops-section";
import LoadingScreen from "../components/loading-screen";
import useUserStore from "../store/userStore";
import { Helmet } from "react-helmet-async";

export default function Home() {
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const lang = i18n.language;
    if (lang === "ar") {
        const metaTitle = "Zabehaty - Online Qurbani & Fresh Meat Delivery";
        const metaDescription =
            "An Emirati company working to provide and develop services for supplying carcasses and livestock in an advanced manner to keep pace with modern life.";
    } else {
        const metaTitle = "Zabehaty - Online Qurbani & Fresh Meat Delivery";
        const metaDescription =
            "An Emirati company working to provide and develop services for supplying carcasses and livestock in an advanced manner to keep pace with modern life.";
    }
    const mainAddress = useUserStore((state) => state.mainAddress);
    const setMainAddress = useUserStore((state) => state.setMainAddress);
    const { data, isFetching } = useQuery({
        queryKey: ["global", "home-page"],
        queryFn: getHomePage,
    });
    if (isFetching) return <LoadingScreen />;
    if (!data) return null;
    return (
        <>
            {" "}
            <Helmet>
                {lang === "ar" ? (
                    <>
                        <title>
                            تطبيق لحوم وذبائح طازجة ومجمدة في الإمارات | حلال
                            مزارعنا
                        </title>
                        <meta
                            name="description"
                            content="حلال مزارعنا تطبيق مختص باللحوم والذبائح الطازجة والمجمدة، مع دواجن، أسماك، بقالة، خضار وفواكه، مستلزمات، زهور وشوكولا. توصيل إلى كل مناطق الإمارات"
                        />
                    </>
                ) : (
                    <>
                        <title>
                            Halal Meat App - Fresh & Frozen in the UAE | Halal
                            Mazarana
                        </title>
                        <meta
                            name="description"
                            content="Halal Mazarana is the UAE's all in one application: fresh & frozen meat, poultry, seafood, groceries, produce, disposable, flowers & chocolates, Delivery to all the Emirates"
                        />
                    </>
                )}
            </Helmet>
            <div className="container flex flex-col gap-y-10 py-10 xl:gap-y-20">
                <Hero sliders={data.slider} />
                <CategoriesSection categories={data.categories} />

                <div className="flex flex-col gap-y-10 xl:gap-y-[68px]">
                    {data.limited_offer && data.limited_offer.length > 0 && (
                        <ProductsSection
                            title={t("limited-offers")}
                            products={data.limited_offer}
                        />
                    )}

                    {data.home_sections.map((section) => {
                        if (
                            section.type === "product" &&
                            section.items.length > 0
                        ) {
                            return (
                                <HomeProductsSection
                                    key={section.name}
                                    items={section.items}
                                    title={section.name}
                                />
                            );
                        }
                        if (
                            section.type === "shop" &&
                            section.items.length > 0
                        ) {
                            return (
                                <HomeShopsSection
                                    key={section.name}
                                    items={section.items}
                                    title={section.name}
                                />
                            );
                        }
                        return null;
                    })}
                </div>
            </div>
        </>
    );
}
